import { useState, useEffect } from "react";
import { humanizeString } from "@/utils/frontend/stringOps";
const RadioButton_2 = ({caption1, caption2, caption3, value1, value2, value3,  callback, callbackObjectKey, defaultChecked}) => {

  const [selectedOption, setSelectedOption] = useState(defaultChecked);
  // console.log('defaultChecked', defaultChecked)
  useEffect(() => {
    setSelectedOption(defaultChecked)
  }, [defaultChecked])
  
  const handleOptionChange = (option) => {
    setSelectedOption(option);
    callback({[callbackObjectKey]: option})
  };
     return (

   <div className="flex my-2 items-center justify-center w-full bg-inherit dark:bg-inherit rounded-lg">
      
        <div
        className={`mx-1 text-gray-800 dark:text-gray-400 w-full border-2 text-xs font-base text-center cursor-pointer py-2 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value1
            ? 'border-indigo-600'
            : 'border-gray-200 dark:border-gray-400'
        }`}
        onClick={() => handleOptionChange(value1)}
      >
        <span className="">{caption1}</span>
        </div>
      

      
        <div
        className={`mx-1 text-gray-800 dark:text-gray-400 w-full border-2 text-xs font-base text-center cursor-pointer py-2 rounded-md ease-in-out duration-300 transition-all ${
          selectedOption === value2
            ? 'border-indigo-600'
            : 'border-gray-200 dark:border-gray-400 '
        }`}
        onClick={() => handleOptionChange(value2)}
      >
        <span className="">{caption2}</span>
        </div>

        {caption3 && value3 && 
                <div
                className={`mx-1 text-gray-800 dark:text-gray-400 w-full border-2 text-xs font-base text-center cursor-pointer py-2 rounded-md ease-in-out duration-300 transition-all ${
                  selectedOption === value3
                    ? 'border-indigo-600'
                    : 'border-gray-200 dark:border-gray-400 '
                }`}
                onClick={() => handleOptionChange(value3)}
              >
                <span className="">{caption3}</span>
                </div>}
      


    </div>

     )
}

export default RadioButton_2